import { useEffect } from 'react';

export const useUploadProfileImage = ({ profileImage, onUpdateProfile, interrupt }) => {
    /**
     * first, an image is uploaded to sdk db via onImageUpload;
     * profileImage is passed as a result of successful upload;
     * profileImage id is set as a profile image via onUpdateProfile;
     */
    useEffect(() => {
        const uploadProfileImage = async profileImageId => {
            await onUpdateProfile({ profileImageId }, {});
        };
        if (profileImage && profileImage.imageId && profileImage.file) {
            uploadProfileImage(profileImage.imageId);
        }
    }, [profileImage]);
};
